import {
  RosterProviderMatchStatus,
  type RosterNameMatch,
} from "@api/shared-runtime/roster-provider-match";
import { Button } from "@/components/ui/button";
import { getMatchName, getMatchStatusLabel } from "./roster-match-labels";

type NameMatchPanelProps = {
  matches: RosterNameMatch[];
  disabled: boolean;
  onViewProvider?: (affiliationId: string) => void;
  onReinstate: (endedAffiliationId: string) => void;
};

export function NameMatchPanel({
  matches,
  disabled,
  onViewProvider,
  onReinstate,
}: NameMatchPanelProps) {
  return (
    <section
      aria-label="Possible matches"
      className="space-y-2 rounded-md border p-3"
    >
      <h3 className="text-sm font-medium">Possible matches</h3>
      <ul className="space-y-2">
        {matches.map((match) => (
          <li
            key={match.id}
            className="flex items-center justify-between gap-3 text-sm"
          >
            <span>
              {getMatchName(match)}
              <span className="block text-xs text-muted-foreground">
                {getMatchStatusLabel(match.status)}
              </span>
            </span>
            {match.status === RosterProviderMatchStatus.Active &&
              match.affiliationId &&
              onViewProvider && (
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  disabled={disabled}
                  onClick={() => onViewProvider(match.affiliationId!)}
                >
                  View provider
                </Button>
              )}
            {match.status === RosterProviderMatchStatus.Ended &&
              match.endedAffiliationId && (
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  disabled={disabled}
                  onClick={() => onReinstate(match.endedAffiliationId!)}
                >
                  Reinstate
                </Button>
              )}
          </li>
        ))}
      </ul>
    </section>
  );
}
